import React, { Component } from "react";
import ReactDOM from "react-dom";


/**
 * Renders children elements under #shell-portal
 * 
 * Use:

                     <div>
                        <ShellPortal>
                         ... w/e
                        </ShellPortal>
                     </div>
  
 */
export default class extends React.PureComponent {
   constructor(props) {
      super(props);
      this.portalEl = document.getElementById("shell-portal");
   }

   render() {
      return ReactDOM.createPortal(this.props.children, this.portalEl);
   }
}



// WEBPACK FOOTER //
// ./src/components/ShellPortal/ShellPortal.js